<template>
  <v-data-table
    :headers="headers"
    :items="chassisNaoVendidos"
    hide-default-footer
    disable-pagination
    dense
    style="white-space: nowrap"
    no-data-text="Nenhum chassi sem venda"
  >
    <template v-slot:[`item.chassi_completo`]="{ item }">
      <span class="caption font-weight-medium" style="font-family: monospace">{{ item.chassi_completo }}</span>
      <span v-if="item.chassi_resumido" class="caption grey--text ml-2" style="font-size: 11px">{{ item.chassi_resumido }}</span>
    </template>
  </v-data-table>
</template>

<script>
import apuracaoTabelaMixin from "@/mixins/apuracaoTabelaMixin";

export default {
  name: "ApuracaoTabelaChassiNaoVendidos",

  mixins: [apuracaoTabelaMixin],

  data() {
    return {
      headers: [
        { text: "Chassi", value: "chassi_completo", sortable: true }
      ]
    };
  },

  computed: {
    chassisNaoVendidos() {
      const vendidos = new Set(
        this.rows
          .filter(r => parseFloat(r.valor_realizado) > 0)
          .map(r => r.chassi_completo)
      );
      const vistos = new Set();
      return this.rows.filter(r => {
        const chassi = r.chassi_completo;
        if (vendidos.has(chassi) || vistos.has(chassi)) return false;
        vistos.add(chassi);
        return true;
      });
    }
  }
};
</script>
